// assets
import { IconBuilding, IconUserPlus, IconPuzzle, IconKey, IconUserCheck, IconSettings } from '@tabler/icons';

// constant
const icons = { IconBuilding, IconUserPlus, IconPuzzle, IconKey, IconUserCheck, IconSettings };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

// This function will be called with the AI evaluation enabled state
export const getAdministratorMenuItems = (aiEvaluationEnabled = false, isOperator = false) => {
  const baseChildren = [
    {
      id: 'admins',
      title: 'Admins',
      type: 'item',
      url: '/administrator/admins',
      icon: icons.IconUserCheck,
      breadcrumbs: false
    },
    {
      id: 'academies',
      title: 'Academies',
      type: 'item',
      url: '/administrator/academies',
      icon: icons.IconBuilding,
      breadcrumbs: false
    },
    {
      id: 'students-bulk',
      title: 'Students (Bulk)',
      type: 'item',
      url: '/administrator/students-bulk',
      icon: icons.IconUserPlus,
      breadcrumbs: false
    },
    {
      id: 'questions-bulk',
      title: 'Questions (Bulk)',
      type: 'item',
      url: '/administrator/questions-bulk',
      icon: icons.IconPuzzle,
      breadcrumbs: false
    },
  ];

  // AI 설정은 학원별이 아니라 **전역 싱글턴**이다 — 한 학원이 바꾸면 전 학원의
  // 채점 모델·프롬프트·API 키가 함께 바뀐다. 그래서 서버가 쓰기를 운영 학원으로
  // 좁혔고(ai_evaluation/permissions.py), 다른 학원 관리자에게는 저장이 403 인
  // 화면만 남는다. 아예 보이지 않게 한다.
  if (aiEvaluationEnabled && isOperator) {
    baseChildren.push({
      id: 'ai-evaluation-settings',
      title: 'AI Evaluation Settings',
      type: 'item',
      url: '/administrator/ai-evaluation-settings',
      icon: icons.IconSettings,
      breadcrumbs: false
    });
  }

  return {
    id: 'administrator',
    title: 'Administrator',
    icon: icons.IconKey,
    type: 'group',
    children: baseChildren
  };
};

// Default export for backward compatibility
const administrator = getAdministratorMenuItems(false);
export default administrator;
